import { ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { DisplayM, LabelL } from 'atoms/typography';

const Root = styled(Vertical)`
  flex: 1;
  background-image: linear-gradient(
      to top,
      var(--c-black),
      var(--c-black) 5%,
      transparent 40%
    ),
    linear-gradient(to right, rgba(var(--c-rgb-black), 0.5), transparent 20%);
  padding: var(--double-unit);
`;

const ChipWithBorder = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: var(--half-unit);
  white-space: nowrap;
  min-height: 32px;
  padding: var(--half-unit) var(--intermediate-unit);
  border: 1px solid var(--c-white);
  border-radius: 16px;
  background: var(--c-nl-200);
  color: var(--c-white);
  text-transform: uppercase;
  text-align: center;
`;

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  chipTitle?: ReactNode;
  children: ReactNode;
  style?: React.CSSProperties;
};

export const Section = ({
  title,
  subtitle,
  chipTitle,
  children,
  style,
}: Props) => {
  return (
    <Root center gap={4} style={style}>
      {chipTitle && (
        <ChipWithBorder>
          <LabelL bold>{chipTitle}</LabelL>
        </ChipWithBorder>
      )}
      <Vertical className="text-center" center gap={1}>
        <DisplayM>{title}</DisplayM>
        <LabelL>{subtitle}</LabelL>
      </Vertical>
      {children}
    </Root>
  );
};
